import { Col, Row, Select } from 'antd';
import React, { useState } from 'react';

import Form from '@/src/shared/components/Form';
import Heading from '@/src/shared/components/Heading';
import X from '@/src/shared/components/Icon/_icons/X';
import Sanitize from '@/src/shared/components/Sanitize';
import { space } from '@/styles';
import { colMdProps, rowProps } from '@/utils/rowColHelpers';
import { multiSelectProps } from '@/utils/selectHelpers';

import style from '../style';

const { Option } = Select;
const { m } = space;
const StatePublications = props => {
  const {
    designData,
    form,
    loading,
    options: { States, Titles },
    profile,
    setManuallyTouched
  } = props;

  const { block, blockComponents } = designData;

  const [stateCount, setStateCount] = useState(
    profile.StatePublications.States ? profile.StatePublications.States.length : 0
  );

  const clear = (fieldName, defaultValue) => {
    form.setFieldsValue({
      [fieldName]: defaultValue,
    });
    setManuallyTouched(true)
  };

  const handleChange = states => {
    setStateCount(states && states.length ? states.length : 0);
  };

  return (
    <>
      <div css={style.rowWidth}>
        <Heading type={2} theme="primaryGray" size="md" weight="bold">
          {block.BlockTitle}
        </Heading>
        {blockComponents.map(c => (
          <div key={c.BlockComponentId} css={style.description}>
            <Sanitize>{c.Paragraph}</Sanitize>
          </div>
        ))}

        <Row {...rowProps} css={m.t16}>
          <Col {...colMdProps}>
            <Form.Item
              css={style.hasClear}
              label={
                <>
                  <span>States</span>
                  <Heading
                    type={3}
                    weight="bolder"
                    size="xs"
                    css={style.publicationClear}
                    onClick={() => clear('StatePublicationsStates', [])}
                  >
                    <X /> <span css={m.l8}>Clear Choices</span>
                  </Heading>
                </>
              }
            >
              {form.getFieldDecorator('StatePublicationsStates', {
                initialValue: profile.StatePublications.States,
              })(
                <Select
                  {...multiSelectProps(false)}
                  loading={loading}
                  maxTagCount={5}
                  size="large"
                  onChange={handleChange}
                  css={style.whiteField}
                >
                  {States.map(p => (
                    <Option key={`${p.StateCode}-state`} value={p.StateCode}>
                      {p.StateDescription}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col {...colMdProps}>
            <Form.Item
              css={style.hasClear}
              label={
                <>
                  <span>Titles</span>
                  <Heading
                    type={3}
                    weight="bolder"
                    size="xs"
                    css={style.publicationClear}
                    onClick={() => clear('StatePublicationsTitles', [])}
                  >
                    <X /> <span css={m.l8}>Clear Choices</span>
                  </Heading>
                </>
              }
            >
              {form.getFieldDecorator('StatePublicationsTitles', {
                initialValue: profile.StatePublications.Titles,
                rules: [{ required: stateCount > 0, message: 'Select a Title.' }],
              })(
                <Select
                  {...multiSelectProps(false)}
                  loading={loading}
                  maxTagCount={5}
                  size="large"
                  css={style.whiteField}
                >
                  {Titles.map(p => (
                    <Option key={`${p.PublicationCode}-state`} value={p.PublicationCode}>
                      {p.PublicationDescription}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default StatePublications;
